"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SCALE_EXPO = exports.START_TRADE_ID = exports.START_OFFER_ID = void 0;
const anchor_1 = require("@project-serum/anchor");
exports.START_OFFER_ID = new anchor_1.BN(11000);
exports.START_TRADE_ID = new anchor_1.BN(9000);
exports.SCALE_EXPO = 9; // using for rate and fiat amount
